import { i18nLike } from "#web/services/i18nLike";
import { Badge, InlineStack, Tooltip } from "@shopify/polaris";

import { LeakedCode } from "../_models/leakedCode";
import { en } from "./translations";

export const SourceBadgeList = ({ leakedCode }: { leakedCode: LeakedCode }) => {
  const t = i18nLike(en);
  const { sources } = leakedCode;
  const MAX_DISPLAYED_SOURCES = 2;

  const displayedSources = sources.slice(0, MAX_DISPLAYED_SOURCES);
  const remainingSources = sources.slice(MAX_DISPLAYED_SOURCES);
  const hasMoreSources = remainingSources.length > 0;

  const displayedBadges = displayedSources.map((source) => {
    const isInternal = source.name === "Coupon Extension";
    return (
      <a href={isInternal ? undefined : source.url} key={source.name} target={isInternal ? undefined : "_blank"}>
        <Badge>{source.name}</Badge>
      </a>
    );
  });

  return (
    <InlineStack blockAlign="center" gap="100" wrap={false}>
      {displayedBadges}
      {hasMoreSources && (
        <Tooltip
          content={
            <div>
              {remainingSources.map((source, index) => (
                <div key={index}>{source.name}</div>
              ))}
            </div>
          }
        >
          <Badge>{`${String(remainingSources.length)} ${t("common.more")}`}</Badge>
        </Tooltip>
      )}
    </InlineStack>
  );
};
